import React, { useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import { fetchDoctorDashboardData } from "../../../../redux/reducers/doctorDashboardSlice";
const TopConsultationsChart = () => {
  const dispatch = useDispatch();
  const { top5VetsByCompletedAppointments, loading, followUpContinuity } =
    useSelector((state) => state.doctorDashboard);

  useEffect(() => {
    dispatch(fetchDoctorDashboardData());
  }, [dispatch]);

  const categories = top5VetsByCompletedAppointments?.map((vet) => vet.doctor);
  const seriesData = top5VetsByCompletedAppointments?.map(
    (vet) => vet?.completedAppointments ?? 0
  );

  const options = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      background: "transparent",
    },
    plotOptions: {
      bar: {
        borderRadius: 8,
        columnWidth: "45%",
        distributed: true,
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "12px",
        fontWeight: "bold",
        colors: ["#fff"],
      },
    },
    xaxis: {
      categories,
      labels: {
        style: {
          fontFamily: "Inter, sans-serif",
          fontSize: "13px",
          colors: "#64748B",
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: "#64748B",
          fontSize: "12px",
        },
      },
    },
    colors: [
      "#6366F1", // Indigo
      "#8B5CF6", // Violet
      "#EC4899", // Pink
      "#F59E0B", // Amber
      "#10B981", // Emerald
    ],
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "vertical",
        shadeIntensity: 0.3,
        gradientToColors: [
          "#4F46E5", // Darker indigo
          "#7C3AED", // Darker violet
          "#DB2777", // Darker pink
          "#D97706", // Darker amber
          "#059669", // Darker emerald
        ],
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 0.9,
      },
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        const label = categories[dataPointIndex];
        const value = series[seriesIndex][dataPointIndex];
        const hoverVetData = top5VetsByCompletedAppointments?.[dataPointIndex];
        const followUpDataMat = followUpContinuity?.find(
          (li) => li?.doctor?.toLowerCase() === label?.toLowerCase()
        );

        // Build follow-up rows if data exists
        let followUpRows = "";
        if (followUpDataMat) {
          followUpRows =
            '<div class="apexcharts-tooltip-y-group">' +
            '<span class="apexcharts-tooltip-text-y-label">Follow Up Kept %: </span>' +
            '<span class="apexcharts-tooltip-text-y-value">' +
            followUpDataMat?.followUpKeptPercentage +
            "</span>" +
            "</div>" +
            '<div class="apexcharts-tooltip-y-group">' +
            '<span class="apexcharts-tooltip-text-y-label">Median Follow Up Gap: </span>' +
            '<span class="apexcharts-tooltip-text-y-value">' +
            followUpDataMat?.medianFollowUpGap +
            "</span>" +
            "</div>";
        }

        return (
          '<div class="apexcharts-tooltip-title" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; background-color: #EBEBEB; color: #000; padding: 8px; margin: 0;">' +
          label +
          '<span class="apexcharts-tooltip-marker" style="background-color: ' +
          w.globals.colors[dataPointIndex] +
          '; margin-left: 5px;"></span>' +
          "</div>" +
          '<div class="apexcharts-tooltip-series-group" style="order: 1; display: flex; background-color: #fff; padding: 8px;">' +
          '<div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #000;">' +
          '<div class="apexcharts-tooltip-y-group">' +
          '<span class="apexcharts-tooltip-text-y-label">Consultations: </span>' +
          '<span class="apexcharts-tooltip-text-y-value">' +
          value +
          "</span>" +
          "</div>" +
          '<div class="apexcharts-tooltip-y-group">' +
          '<span class="apexcharts-tooltip-text-y-label">Follow Up: </span>' +
          '<span class="apexcharts-tooltip-text-y-value">' +
          hoverVetData?.followUpCount +
          "</span>" +
          "</div>" +
          '<div class="apexcharts-tooltip-y-group">' +
          '<span class="apexcharts-tooltip-text-y-label">Repeat Visit: </span>' +
          '<span class="apexcharts-tooltip-text-y-value">' +
          hoverVetData?.repeatVisitPercentage +
          "</span>" +
          "</div>" +
          followUpRows +
          "</div>" +
          "</div>"
        );
      },
    },
    grid: {
      borderColor: "#E2E8F0",
      strokeDashArray: 3,
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
  };

  if (loading && !top5VetsByCompletedAppointments?.length) {
    return (
      <div className="rounded-lg shadow border border-gray-200 bg-white p-6">
        Loading...
      </div>
    );
  }

  return (
    <div className="rounded-lg shadow border border-gray-200 bg-white p-6">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold text-gray-800">
          Number of Consultations (Top 5 Vets)
        </h3>
      </div>
      <ReactApexChart
        options={options}
        series={[{ name: "Consultations", data: seriesData }]}
        type="bar"
        height={320}
      />
    </div>
  );
};

export default TopConsultationsChart;
